import { jwtClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { AUTH_SERVER_URL } from "@/env";

export const authClient = createAuthClient({
  baseURL: AUTH_SERVER_URL,
  credentials: "include",
  plugins: [jwtClient()],
});

export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
  token: getToken,
} = authClient;
